// Angular
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * A custom validator to check if the autocomplete has a selected option.
 */
export function AutocompleteRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // If the control has null or undefined value it's invalid
    if (!control.value) {
      return { autocompleteRequired: true };
    }

    // If the control value is a string, it's invalid
    if (typeof control.value === 'string') {
      return { autocompleteRequired: true };
    }

    // Must be an FsxOption<string> so is valid
    return null;
  };
}